import axios from "@/util/axios";

const PREFIX_URI = "/luqiao/attendance/warn/config";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 根据ID查询 */
    getById: (id) => axios.get({url: `${PREFIX_URI}/getById`, data: {id: id}}),

    /** 保存或修改 */
    saveSubmit: (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),

    /** 启用/禁用 */
    toggleEnable: (id, isEnabled) => axios.get({url: `${PREFIX_URI}/toggleEnable`, data: {id: id, isEnabled: isEnabled}}),

    /** 查询启用的配置列表 */
    listEnabled: (merchantId) => axios.get({url: `${PREFIX_URI}/listEnabled`, data: {merchantId: merchantId}})
};

